import React, { useEffect, useRef, useState } from "react";
//*MUI
import {
  Box,
  Modal,
  Stack,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Accordion,
  AccordionSummary,
  Typography,
  FormLabel,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
//*files
import cssClasses from "./PreviewAggrementConfirmationModal.module.css";
import Button from "../../../../Subcomponents/Button";
import CustomInput from "../../../../Subcomponents/CustomInput";
import DropDown from "../../../../Subcomponents/DropDown";
import LeadStatusChip from "../../../../Subcomponents/LeadStatusChip";
import Dot from "../../../Icons/Dot";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import buildingImg from "../../../../Assets/Images/building-4.svg";
import Checkbox from "@mui/material/Checkbox";
import {
  getAggrementId,
  getApplicantId,
} from "../../../../Services/AllAllotments";
import { dismissLoader, presentLoader } from "../../../../Services/loader";
import { errorTost } from "../../../../Services/Toast";
import PreviewAggrementImageModal from "../../../FileManager/PreviewAggrementImageModal";
import html2pdf from 'html2pdf.js';
import { useSelector } from "react-redux";

function PreviewAggrementConfirmationModal({ open, handleClose, allotment, tabName, isCreateDraft = false, handleCreateDraft = () => { } }) {
  const [state, setState] = useState({});
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState({});
  const [name, SetName] = useState("");
  const printRef = useRef();
  const loggedInUser = useSelector((state) => state.Auth.user);

  useEffect(() => {
    if (allotment) {
      function getModalData(d) {
        presentLoader();
        getAggrementId(d?.allotment_payment_id)
          .then((response) => {
            getApplicantId(response.data[0]?.agreementFormId)
              .then((val) => {
                dismissLoader();
                const newData = {
                  ...response,
                  val,
                  allotment,
                };
                setState(newData);
              })
              .catch((e) => {
                dismissLoader();
                errorTost(e.message);
              });
          })
          .catch((e) => {
            dismissLoader();
            errorTost(e.message);
          });
      }
      getModalData(allotment);
    }
  }, [allotment]);
  const labelStyle = {
    fontFamily: "Inter-Medium",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "1.4rem",
    lineHeight: "2rem",
    color: "#344054",
    marginBottom: "0.6rem",
  };

  function getDateInFormat(d) {
    const date = new Date(d);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }

  const aggrementData = state;

  const bankType = aggrementData?.data?.[0]?.bankType;
  const MODAL_DATA = aggrementData?.val?.data || [];
  let modalData = new Array(4);
  MODAL_DATA.forEach((data) => {
    if (data.type === "first") modalData[0] = data;
    if (data.type === "second") modalData[1] = data;
    if (data.type === "third") modalData[2] = data;
    if (data.type === "fourth") modalData[3] = data;
  });
  const Project_Name = aggrementData?.allotment?.project_name;
  const HeaderFirst_Name = aggrementData?.allotment?.wing_name;
  const HeaderSecond_Name = aggrementData?.allotment?.unit_no;
  const Status = aggrementData.allotment?.sdrcomplete;
  const header = HeaderFirst_Name + "- " + HeaderSecond_Name;
  const isSelfFunded = aggrementData?.data?.[0]?.isSelfFunded ? "no" : "yes";

  const radioName =
    bankType === "nbfc"
      ? aggrementData?.data?.[0]?.nbfcId?.nbfcName
      : aggrementData.data?.[0]?.bankId ? aggrementData.data?.[0]?.bankId?.bankName : "Other";
  const otherBank = aggrementData.data?.[0]?.otherBank;

  const handleOpenPreviewModal = (value, name) => {
    setShowPreviewModal(true);
    setSelectedFile(value);
    SetName(name);
  };
  const convertToPdf = () => {
    const element = printRef.current;

    const opt = {
      margin: 0,
      filename: `${header}_AgreementForm.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().from(element).set(opt).save();
  };
  return (
    <>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
        }}
        sx={[
          {
            ".MuiBackdrop-root": {
              background: "rgba(193, 201, 210, 0.7)",
            },
          },
        ]}
        disableAutoFocus={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={cssClasses.modalWrapper}>
          <div className={cssClasses.headerDiv}>
            <Box className={cssClasses.flexRow}>
              <Box className={cssClasses.flexRow}>
                <Box className={cssClasses.flexCol}>
                  <Box className={cssClasses.flexRow}>
                    <div
                      style={{
                        // border: '2px solid red',
                        padding: "1rem",
                        borderRadius: "50%",
                        background: "#ffff",
                      }}
                    >
                      <img src={buildingImg} alt="buildingImg" />
                    </div>
                  </Box>
                </Box>
                <div style={{ display: "flex", justifyContent: "flex-start" }}>
                  <Box className={cssClasses.flexCol}>
                    <p className={cssClasses.HeaderTitle}> {header}</p>
                    <p className={cssClasses.HeaderSubTitle}> {Project_Name}</p>
                  </Box>
                </div>
                <div className={cssClasses.chipWrapper} style={{ gap: "0px" }}>
                  <div className={cssClasses.tokenStatus}>
                    {Status ? (
                      <LeadStatusChip
                        label={"SDR Complete"}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{
                          color: "rgb(2, 122, 72)",
                          backgroundColor: "rgb(236, 253, 243)",
                        }}
                      />
                    ) : (
                      <LeadStatusChip
                        label={"SDR Pending"}
                        icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
                        style={{ color: "#B42318", backgroundColor: "#FEF3F2" }}
                      />
                    )}
                  </div>
                </div>
              </Box>
              <Box className={cssClasses.flexRow}>
                {/* <ThreeDotsMenu list={[]} /> */}
              </Box>
            </Box>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#006AFF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Inter-Medium !important",
                  width: "20%",
                }}
                btnName={"Download"}
                clicked={() => convertToPdf()}
                disable={!loggedInUser?.roleId?.accessibleTabs?.["All Allotments"]?.CRM?.[tabName]?.["Download Agreement Form"]?.isAccessible}
              />
            </div>
          </div>

          <div className={cssClasses.mainContainer} ref={printRef}>
            {modalData?.map((d, index) => {
              return (
                <>
                  {d?.type == "first" && (
                    <div className={cssClasses.formContainer}>
                      <div className={cssClasses.formHeader}>
                        <h2>Primary Applicant</h2>
                        <p className={cssClasses.limitText}>*Limit: 4 Applicants</p>
                      </div>
                      <div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="salutation">Salutation *</label>
                            <select disabled id="salutation" name="salutation" required>
                              <option value={d?.applicant?.salutation}>{d?.applicant?.salutation}</option>
                            </select>
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="first-name">First Name *</label>
                            <input disabled type="text" id="first-name" name="first-name" value={d?.applicant?.firstName} required />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="middle-name">Middle Name</label>
                            <input disabled type="text" id="middle-name" name="middle-name" value={d?.applicant?.middleName} />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="last-name">Last Name *</label>
                            <input disabled type="text" id="last-name" name="last-name" value={d?.applicant?.lastName} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="dob">Date of Birth *</label>
                            <input disabled type="text" id="dob" name="dob" value={getDateInFormat(d?.applicant?.leadDob)} required />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="age">Age *</label>
                            <input disabled type="text" id="age" name="age" value={d?.applicant?.age} required />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="gender">Gender *</label>
                            <input disabled type="text" id="gender" name="gender" value={d?.applicant?.gender} required />
                          </div>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="occupation">Occupation *</label>
                            <input disabled type="text" id="occupation" name="occupation" value={d?.applicant.occupation === "Other" ? d?.applicant.otherOccupation : d?.applicant.occupation} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="aadharNumber">Aadhar Number *</label>
                            <input disabled type="text" id="aadharNumber" name="aadharNumber" value={d?.applicant?.aadharNumber} required />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="panNumber">PAN Number *</label>
                            <input disabled type="text" id="panNumber" name="panNumber" value={d?.applicant?.panNumber} required />
                          </div>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="nameAsperPAN">Name As Per PAN *</label>
                            <input disabled type="text" id="nameAsperPAN" name="nameAsperPAN" value={d?.applicant.nameAsperPAN} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="addressLine1">Address Line 1 *</label>
                            <input disabled type="text" id="addressLine1" name="addressLine1" value={d?.applicant.addressLine1} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="addressLine2">Address Line 2 *</label>
                            <input disabled type="text" id="addressLine2" name="addressLine2" value={d?.applicant.addressLine2} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="addressLine3">Address Line 3 *</label>
                            <input disabled type="text" id="addressLine3" name="addressLine3" value={d?.applicant.addressLine3} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="pincode">Pincode *</label>
                            <input disabled type="text" id="pincode" name="pincode" value={d?.applicant?.pincode} required />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="country">Country *</label>
                            <input disabled type="text" id="country" name="country" value={d?.applicant?.country} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="state">State *</label>
                            <input disabled type="text" id="state" name="state" value={d?.applicant?.state} required />
                          </div>

                          <div className={cssClasses.formGroup}>
                            <label htmlFor="city">City *</label>
                            <input disabled type="text" id="city" name="city" value={d?.applicant?.city} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="contactNumber">Contact Number *</label>
                            <input disabled type="text" id="contactNumber" name="contactNumber" value={d?.applicant?.contactNumber} required />
                          </div>
                          <div className={cssClasses.formGroup}>
                            <label htmlFor="email">Email *</label>
                            <input disabled type="text" id="email" name="email" value={d?.applicant?.email} required />
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <label>Aadhar Card *</label>
                            {d?.applicant?.aadharFileUrl && (
                              <>
                                {d?.applicant?.aadharFileUrl?.type ===
                                  "image" ? (
                                  <>
                                    <div>
                                      <div
                                        style={{
                                          marginBottom: "1rem",
                                        }}
                                      >
                                        <div className={cssClasses.fileNameStyle}
                                          onClick={() => {
                                            handleOpenPreviewModal(
                                              d?.applicant?.aadharFileUrl
                                                ?.url1,
                                              "Adhar Card"
                                            );
                                          }}
                                        >{typeof d?.applicant?.aadharFileUrl
                                          ?.url1 === "string"
                                          ? d?.applicant?.aadharFileUrl?.url1
                                            .split("/")
                                            .pop()
                                          : d?.applicant?.aadharFileUrl
                                            .name}</div>
                                      </div>
                                      <div className={cssClasses.fileNameStyle} onClick={() => {
                                        handleOpenPreviewModal(
                                          d?.applicant?.aadharFileUrl?.url2,
                                          "Adhar Card"
                                        );
                                      }}>{
                                          typeof d?.applicant?.aadharFileUrl
                                            ?.url1 === "string"
                                            ? d?.applicant?.aadharFileUrl?.url2
                                              .split("/")
                                              .pop()
                                            : d?.applicant?.aadharFileUrl.name
                                        }</div>
                                    </div>
                                  </>
                                ) : typeof d?.applicant?.aadharFileUrl ===
                                  "string" ? (
                                  <div className={cssClasses.fileNameStyle} onClick={() => {
                                    handleOpenPreviewModal(
                                      d?.applicant?.aadharFileUrl,
                                      "Adhar Card"
                                    );
                                  }}>
                                    {
                                      typeof d?.applicant?.aadharFileUrl ===
                                        "string"
                                        ? d?.applicant?.aadharFileUrl
                                          ?.split("/")
                                          .pop()
                                        : d?.applicant?.aadharFileUrl.name
                                    }
                                  </div>
                                ) : (
                                  <div className={cssClasses.fileNameStyle} onClick={() => {
                                    handleOpenPreviewModal(
                                      d?.applicant?.aadharFileUrl?.url1,
                                      "Adhar Card"
                                    );
                                  }}>
                                    {
                                      typeof d?.applicant?.aadharFileUrl
                                        ?.url1 === "string"
                                        ? d?.applicant?.aadharFileUrl?.url1
                                          .split("/")
                                          .pop()
                                        : d?.applicant?.aadharFileUrl.name
                                    }
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                          <div className={cssClasses.formGroup}>
                            <label>PAN Card *</label>
                            {d?.applicant?.panFileUrl &&
                              (typeof d?.applicant?.panFileUrl ===
                                "string" ? (
                                <div className={cssClasses.fileNameStyle} onClick={() => {
                                  handleOpenPreviewModal(
                                    d?.applicant?.panFileUrl,
                                    "PAN Card"
                                  );
                                }}>
                                  {
                                    typeof d?.applicant?.panFileUrl ===
                                      "string"
                                      ? d?.applicant?.panFileUrl
                                        ?.split("/")
                                        .pop()
                                      : d?.applicant?.panFileUrl.name
                                  }
                                </div>
                              ) : (
                                <div className={cssClasses.fileNameStyle} onClick={() => {
                                  handleOpenPreviewModal(
                                    d?.applicant?.panFileUrl?.url,
                                    "PAN Card"
                                  );
                                }}>{
                                    typeof d?.applicant?.panFileUrl.url ===
                                      "string"
                                      ? d?.applicant?.panFileUrl?.url
                                        .split("/")
                                        .pop()
                                      : d?.applicant?.panFileUrl.name
                                  }</div>
                              ))}
                          </div>
                        </div>
                        <div className={cssClasses.formMainData}>
                          <div className={cssClasses.formGroup}>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  disabled
                                  defaultChecked={d?.POA}
                                  color="secondary"
                                />
                              }
                              label="POA"
                            /></div>
                        </div>
                      </div>
                      {d?.POA && (
                        <div style={{ pageBreakBefore: "always" }}>
                          <hr style={{ color: "#5f6368" }} />
                          <div
                            className={cssClasses.middleDivHeaderDiv}
                          >
                            <div className={cssClasses.formHeader}>
                              <h2>POA</h2>
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="salutation">Salutation *</label>
                              <select disabled id="salutation" name="salutation" required>
                                <option value={d?.applicant?.salutation}>{d?.POA?.salutation}</option>
                              </select>
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="first-name">First Name *</label>
                              <input disabled type="text" id="first-name" name="first-name" value={d?.POA?.firstName} required />
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="middle-name">Middle Name</label>
                              <input disabled type="text" id="middle-name" name="middle-name" value={d?.POA?.middleName} />
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="last-name">Last Name *</label>
                              <input disabled type="text" id="last-name" name="last-name" value={d?.POA?.lastName} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="age">Age *</label>
                              <input disabled type="text" id="age" name="age" value={d?.POA?.age} required />
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="gender">Gender *</label>
                              <input disabled type="text" id="gender" name="gender" value={d?.POA?.gender} required />
                            </div>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="occupation">Occupation *</label>
                              <input disabled type="text" id="occupation" name="occupation" value={d?.POA.occupation === "Other" ? d?.POA.otherOccupation : d?.POA.occupation} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="aadharNumber">Aadhar Number *</label>
                              <input disabled type="text" id="aadharNumber" name="aadharNumber" value={d?.POA?.aadharNumber} required />
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="panNumber">PAN Number *</label>
                              <input disabled type="text" id="panNumber" name="panNumber" value={d?.POA?.panNumber} required />
                            </div>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="nameAsperPAN">Name As Per PAN *</label>
                              <input disabled type="text" id="nameAsperPAN" name="nameAsperPAN" value={d?.POA.nameAsperPAN} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="addressLine1">Address Line 1 *</label>
                              <input disabled type="text" id="addressLine1" name="addressLine1" value={d?.POA.addressLine1} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="addressLine2">Address Line 2 *</label>
                              <input disabled type="text" id="addressLine2" name="addressLine2" value={d?.POA.addressLine2} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="addressLine3">Address Line 3 *</label>
                              <input disabled type="text" id="addressLine3" name="addressLine3" value={d?.POA.addressLine3} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="pincode">Pincode *</label>
                              <input disabled type="text" id="pincode" name="pincode" value={d?.POA?.pincode} required />
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="country">Country *</label>
                              <input disabled type="text" id="country" name="country" value={d?.applicant?.country} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="state">State *</label>
                              <input disabled type="text" id="state" name="state" value={d?.POA?.state} required />
                            </div>

                            <div className={cssClasses.formGroup}>
                              <label htmlFor="city">City *</label>
                              <input disabled type="text" id="city" name="city" value={d?.POA?.city} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="contactNumber">Contact Number *</label>
                              <input disabled type="text" id="contactNumber" name="contactNumber" value={d?.POA?.contactNumber} required />
                            </div>
                            <div className={cssClasses.formGroup}>
                              <label htmlFor="email">Email *</label>
                              <input disabled type="text" id="email" name="email" value={d?.POA?.email} required />
                            </div>
                          </div>
                          <div className={cssClasses.formMainData}>
                            <div className={cssClasses.formGroup}>
                              <label>Aadhar Card *</label>
                              {d?.POA?.aadharFileUrl && (
                                <>
                                  {d?.POA?.aadharFileUrl?.type ===
                                    "image" ? (
                                    <>
                                      <div>
                                        <div
                                          style={{
                                            marginBottom: "1rem",
                                          }}
                                        >
                                          <div className={cssClasses.fileNameStyle} onClick={() => {
                                            handleOpenPreviewModal(
                                              d?.POA?.aadharFileUrl
                                                ?.url1,
                                              "Adhar Card"
                                            );
                                          }}>
                                            {
                                              typeof d?.POA?.aadharFileUrl
                                                ?.url1 === "string"
                                                ? d?.POA?.aadharFileUrl?.url1
                                                  .split("/")
                                                  .pop()
                                                : d?.POA?.aadharFileUrl.url1
                                                  .name
                                            }
                                          </div>
                                        </div>
                                        <div className={cssClasses.fileNameStyle} onClick={() => {
                                          handleOpenPreviewModal(
                                            d?.POA?.aadharFileUrl?.url2,
                                            "Adhar Card"
                                          );
                                        }}>{
                                            typeof d?.POA?.aadharFileUrl
                                              ?.url2 === "string"
                                              ? d?.POA?.aadharFileUrl?.url2
                                                .split("/")
                                                .pop()
                                              : d?.POA?.aadharFileUrl?.url2.name
                                          }</div>
                                      </div>
                                    </>
                                  ) : typeof d?.applicant?.aadharFileUrl ===
                                    "string" ? (
                                    <div className={cssClasses.fileNameStyle} onClick={() => {
                                      handleOpenPreviewModal(
                                        d?.POA?.aadharFileUrl,
                                        "Adhar Card"
                                      );
                                    }}>
                                      {
                                        typeof d?.POA?.aadharFileUrl ===
                                          "string"
                                          ? d?.POA?.aadharFileUrl
                                            ?.split("/")
                                            .pop()
                                          : d?.POA?.aadharFileUrl.name
                                      }
                                    </div>
                                  ) : (
                                    <div className={cssClasses.fileNameStyle} onClick={() => {
                                      handleOpenPreviewModal(
                                        d?.POA?.aadharFileUrl?.url1,
                                        "Adhar Card"
                                      );
                                    }}>{
                                        typeof d?.POA?.aadharFileUrl
                                          ?.url1 === "string"
                                          ? d?.POA?.aadharFileUrl?.url1
                                            .split("/")
                                            .pop()
                                          : d?.POA?.aadharFileUrl?.url1.name
                                      }</div>
                                  )}
                                </>
                              )}
                            </div>
                            <div className={cssClasses.formGroup}>
                              <label>PAN Card *</label>
                              {d?.POA?.panFileUrl &&
                                (typeof d?.POA?.panFileUrl ===
                                  "string" ? (
                                  <div className={cssClasses.fileNameStyle} onClick={() => {
                                    handleOpenPreviewModal(
                                      d?.POA?.panFileUrl,
                                      "PAN Card"
                                    );
                                  }}>
                                    {
                                      typeof d?.POA?.panFileUrl ===
                                        "string"
                                        ? d?.POA?.panFileUrl
                                          ?.split("/")
                                          .pop()
                                        : d?.POA?.panFileUrl?.name
                                    }
                                  </div>

                                ) : (
                                  <div className={cssClasses.fileNameStyle} onClick={() => {
                                    handleOpenPreviewModal(
                                      d?.POA?.panFileUrl?.url,
                                      "PAN Card"
                                    );
                                  }}>
                                    {
                                      typeof d?.POA?.panFileUrl?.url ===
                                        "string"
                                        ? d?.POA?.panFileUrl?.url
                                          .split("/")
                                          .pop()
                                        : d?.POA?.panFileUrl.name
                                    }
                                  </div>
                                ))}                   </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  {d?.type != "first" && (
                    // <Box padding={6}>
                    <div className={cssClasses.accordionDiv} style={{ pageBreakBefore: "always" }}>
                      <Accordion defaultExpanded>
                        <AccordionSummary
                          expandIcon={
                            <KeyboardArrowRightIcon
                              sx={{ fontSize: "2rem" }}
                            />
                          }
                        >
                          <p
                            className={cssClasses.MiddleDivHeaderTitle}
                          >{`Applicant ${index + 1}`}</p>
                        </AccordionSummary>
                        <AccordionDetails>
                          <div className={cssClasses.formContainerAccordian}>
                            <div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="salutation">Salutation *</label>
                                  <select disabled id="salutation" name="salutation" required>
                                    <option value={d?.applicant?.salutation}>{d?.applicant?.salutation}</option>
                                  </select>
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="first-name">First Name *</label>
                                  <input disabled type="text" id="first-name" name="first-name" value={d?.applicant?.firstName} required />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="middle-name">Middle Name</label>
                                  <input disabled type="text" id="middle-name" name="middle-name" value={d?.applicant?.middleName} />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="last-name">Last Name *</label>
                                  <input disabled type="text" id="last-name" name="last-name" value={d?.applicant?.lastName} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="dob">Date of Birth *</label>
                                  <input disabled type="text" id="dob" name="dob" value={getDateInFormat(d?.applicant?.leadDob)} required />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="age">Age *</label>
                                  <input disabled type="text" id="age" name="age" value={d?.applicant?.age} required />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="gender">Gender *</label>
                                  <input disabled type="text" id="gender" name="gender" value={d?.applicant?.gender} required />
                                </div>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="occupation">Occupation *</label>
                                  <input disabled type="text" id="occupation" name="occupation" value={d?.applicant.occupation === "Other" ? d?.applicant.otherOccupation : d?.applicant.occupation} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="aadharNumber">Aadhar Number *</label>
                                  <input disabled type="text" id="aadharNumber" name="aadharNumber" value={d?.applicant?.aadharNumber} required />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="panNumber">PAN Number *</label>
                                  <input disabled type="text" id="panNumber" name="panNumber" value={d?.applicant?.panNumber} required />
                                </div>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="nameAsperPAN">Name As Per PAN *</label>
                                  <input disabled type="text" id="nameAsperPAN" name="nameAsperPAN" value={d?.applicant.nameAsperPAN} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="addressLine1">Address Line 1 *</label>
                                  <input disabled type="text" id="addressLine1" name="addressLine1" value={d?.applicant.addressLine1} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="addressLine2">Address Line 2 *</label>
                                  <input disabled type="text" id="addressLine2" name="addressLine2" value={d?.applicant.addressLine2} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="addressLine3">Address Line 3 *</label>
                                  <input disabled type="text" id="addressLine3" name="addressLine3" value={d?.applicant.addressLine3} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="pincode">Pincode *</label>
                                  <input disabled type="text" id="pincode" name="pincode" value={d?.applicant?.pincode} required />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="country">Country *</label>
                                  <input disabled type="text" id="country" name="country" value={d?.applicant?.country} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="state">State *</label>
                                  <input disabled type="text" id="state" name="state" value={d?.applicant?.state} required />
                                </div>

                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="city">City *</label>
                                  <input disabled type="text" id="city" name="city" value={d?.applicant?.city} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="contactNumber">Contact Number *</label>
                                  <input disabled type="text" id="contactNumber" name="contactNumber" value={d?.applicant?.contactNumber} required />
                                </div>
                                <div className={cssClasses.formGroup}>
                                  <label htmlFor="email">Email *</label>
                                  <input disabled type="text" id="email" name="email" value={d?.applicant?.email} required />
                                </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <label>Aadhar Card *</label>
                                  {d?.applicant?.aadharFileUrl && (
                                    <>
                                      {d?.applicant?.aadharFileUrl?.type ===
                                        "image" ? (
                                        <>
                                          <div>
                                            <div
                                              style={{
                                                marginBottom: "1rem",
                                              }}
                                            >
                                              <div className={cssClasses.fileNameStyle}
                                                onClick={() => {
                                                  handleOpenPreviewModal(
                                                    d?.applicant?.aadharFileUrl
                                                      ?.url1,
                                                    "Adhar Card"
                                                  );
                                                }}
                                              >{typeof d?.applicant?.aadharFileUrl
                                                ?.url1 === "string"
                                                ? d?.applicant?.aadharFileUrl?.url1
                                                  .split("/")
                                                  .pop()
                                                : d?.applicant?.aadharFileUrl
                                                  .name}</div>
                                            </div>
                                            <div className={cssClasses.fileNameStyle} onClick={() => {
                                              handleOpenPreviewModal(
                                                d?.applicant?.aadharFileUrl?.url2,
                                                "Adhar Card"
                                              );
                                            }}>{
                                                typeof d?.applicant?.aadharFileUrl
                                                  ?.url1 === "string"
                                                  ? d?.applicant?.aadharFileUrl?.url2
                                                    .split("/")
                                                    .pop()
                                                  : d?.applicant?.aadharFileUrl.name
                                              }</div>
                                          </div>
                                        </>
                                      ) : typeof d?.applicant?.aadharFileUrl ===
                                        "string" ? (
                                        <div className={cssClasses.fileNameStyle} onClick={() => {
                                          handleOpenPreviewModal(
                                            d?.applicant?.aadharFileUrl,
                                            "Adhar Card"
                                          );
                                        }}>
                                          {
                                            typeof d?.applicant?.aadharFileUrl ===
                                              "string"
                                              ? d?.applicant?.aadharFileUrl
                                                ?.split("/")
                                                .pop()
                                              : d?.applicant?.aadharFileUrl.name
                                          }
                                        </div>
                                      ) : (
                                        <div className={cssClasses.fileNameStyle} onClick={() => {
                                          handleOpenPreviewModal(
                                            d?.applicant?.aadharFileUrl?.url1,
                                            "Adhar Card"
                                          );
                                        }}>
                                          {
                                            typeof d?.applicant?.aadharFileUrl
                                              ?.url1 === "string"
                                              ? d?.applicant?.aadharFileUrl?.url1
                                                .split("/")
                                                .pop()
                                              : d?.applicant?.aadharFileUrl.name
                                          }
                                        </div>
                                      )}
                                    </>
                                  )}
                                </div>
                                <div className={cssClasses.formGroup}>
                                  <label>PAN Card *</label>
                                  {d?.applicant?.panFileUrl &&
                                    (typeof d?.applicant?.panFileUrl ===
                                      "string" ? (
                                      <div className={cssClasses.fileNameStyle} onClick={() => {
                                        handleOpenPreviewModal(
                                          d?.applicant?.panFileUrl,
                                          "PAN Card"
                                        );
                                      }}>
                                        {
                                          typeof d?.applicant?.panFileUrl ===
                                            "string"
                                            ? d?.applicant?.panFileUrl
                                              ?.split("/")
                                              .pop()
                                            : d?.applicant?.panFileUrl.name
                                        }
                                      </div>
                                    ) : (
                                      <div className={cssClasses.fileNameStyle} onClick={() => {
                                        handleOpenPreviewModal(
                                          d?.applicant?.panFileUrl?.url,
                                          "PAN Card"
                                        );
                                      }}>{
                                          typeof d?.applicant?.panFileUrl.url ===
                                            "string"
                                            ? d?.applicant?.panFileUrl?.url
                                              .split("/")
                                              .pop()
                                            : d?.applicant?.panFileUrl.name
                                        }</div>
                                    ))}                         </div>
                              </div>
                              <div className={cssClasses.formMainData}>
                                <div className={cssClasses.formGroup}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        disabled
                                        defaultChecked={d?.POA}
                                        color="secondary"
                                      />
                                    }
                                    label="POA"
                                  /></div>
                              </div>
                            </div>
                            {d?.POA && (
                              <div style={{ pageBreakBefore: "always" }}>
                                <hr style={{ color: "#5f6368" }} />
                                <div
                                  className={cssClasses.middleDivHeaderDiv}
                                >
                                  <div className={cssClasses.formHeader}>
                                    <h2>POA</h2>
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="salutation">Salutation *</label>
                                    <select disabled id="salutation" name="salutation" required>
                                      <option value={d?.applicant?.salutation}>{d?.POA?.salutation}</option>
                                    </select>
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="first-name">First Name *</label>
                                    <input disabled type="text" id="first-name" name="first-name" value={d?.POA?.firstName} required />
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="middle-name">Middle Name</label>
                                    <input disabled type="text" id="middle-name" name="middle-name" value={d?.POA?.middleName} />
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="last-name">Last Name *</label>
                                    <input disabled type="text" id="last-name" name="last-name" value={d?.POA?.lastName} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="age">Age *</label>
                                    <input disabled type="text" id="age" name="age" value={d?.POA?.age} required />
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="gender">Gender *</label>
                                    <input disabled type="text" id="gender" name="gender" value={d?.POA?.gender} required />
                                  </div>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="occupation">Occupation *</label>
                                    <input disabled type="text" id="occupation" name="occupation" value={d?.POA.occupation === "Other" ? d?.POA.otherOccupation : d?.POA.occupation} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="aadharNumber">Aadhar Number *</label>
                                    <input disabled type="text" id="aadharNumber" name="aadharNumber" value={d?.POA?.aadharNumber} required />
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="panNumber">PAN Number *</label>
                                    <input disabled type="text" id="panNumber" name="panNumber" value={d?.POA?.panNumber} required />
                                  </div>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="nameAsperPAN">Name As Per PAN *</label>
                                    <input disabled type="text" id="nameAsperPAN" name="nameAsperPAN" value={d?.POA.nameAsperPAN} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="addressLine1">Address Line 1 *</label>
                                    <input disabled type="text" id="addressLine1" name="addressLine1" value={d?.POA.addressLine1} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="addressLine2">Address Line 2 *</label>
                                    <input disabled type="text" id="addressLine2" name="addressLine2" value={d?.POA.addressLine2} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="addressLine3">Address Line 3 *</label>
                                    <input disabled type="text" id="addressLine3" name="addressLine3" value={d?.POA.addressLine3} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="pincode">Pincode *</label>
                                    <input disabled type="text" id="pincode" name="pincode" value={d?.POA?.pincode} required />
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="country">Country *</label>
                                    <input disabled type="text" id="country" name="country" value={d?.applicant?.country} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="state">State *</label>
                                    <input disabled type="text" id="state" name="state" value={d?.POA?.state} required />
                                  </div>

                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="city">City *</label>
                                    <input disabled type="text" id="city" name="city" value={d?.POA?.city} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="contactNumber">Contact Number *</label>
                                    <input disabled type="text" id="contactNumber" name="contactNumber" value={d?.POA?.contactNumber} required />
                                  </div>
                                  <div className={cssClasses.formGroup}>
                                    <label htmlFor="email">Email *</label>
                                    <input disabled type="text" id="email" name="email" value={d?.POA?.email} required />
                                  </div>
                                </div>
                                <div className={cssClasses.formMainData}>
                                  <div className={cssClasses.formGroup}>
                                    <label>Aadhar Card *</label>
                                    {d?.POA?.aadharFileUrl && (
                                      <>
                                        {d?.POA?.aadharFileUrl?.type ===
                                          "image" ? (
                                          <>
                                            <div>
                                              <div
                                                style={{
                                                  marginBottom: "1rem",
                                                }}
                                              >
                                                <div className={cssClasses.fileNameStyle} onClick={() => {
                                                  handleOpenPreviewModal(
                                                    d?.POA?.aadharFileUrl
                                                      ?.url1,
                                                    "Adhar Card"
                                                  );
                                                }}>
                                                  {
                                                    typeof d?.POA?.aadharFileUrl
                                                      ?.url1 === "string"
                                                      ? d?.POA?.aadharFileUrl?.url1
                                                        .split("/")
                                                        .pop()
                                                      : d?.POA?.aadharFileUrl.url1
                                                        .name
                                                  }
                                                </div>
                                              </div>
                                              <div className={cssClasses.fileNameStyle} onClick={() => {
                                                handleOpenPreviewModal(
                                                  d?.POA?.aadharFileUrl?.url2,
                                                  "Adhar Card"
                                                );
                                              }}>{
                                                  typeof d?.POA?.aadharFileUrl
                                                    ?.url2 === "string"
                                                    ? d?.POA?.aadharFileUrl?.url2
                                                      .split("/")
                                                      .pop()
                                                    : d?.POA?.aadharFileUrl?.url2.name
                                                }</div>
                                            </div>
                                          </>
                                        ) : typeof d?.applicant?.aadharFileUrl ===
                                          "string" ? (
                                          <div className={cssClasses.fileNameStyle} onClick={() => {
                                            handleOpenPreviewModal(
                                              d?.POA?.aadharFileUrl,
                                              "Adhar Card"
                                            );
                                          }}>
                                            {
                                              typeof d?.POA?.aadharFileUrl ===
                                                "string"
                                                ? d?.POA?.aadharFileUrl
                                                  ?.split("/")
                                                  .pop()
                                                : d?.POA?.aadharFileUrl.name
                                            }
                                          </div>
                                        ) : (
                                          <div className={cssClasses.fileNameStyle} onClick={() => {
                                            handleOpenPreviewModal(
                                              d?.POA?.aadharFileUrl?.url1,
                                              "Adhar Card"
                                            );
                                          }}>{
                                              typeof d?.POA?.aadharFileUrl
                                                ?.url1 === "string"
                                                ? d?.POA?.aadharFileUrl?.url1
                                                  .split("/")
                                                  .pop()
                                                : d?.POA?.aadharFileUrl?.url1.name
                                            }</div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                  <div className={cssClasses.formGroup}>
                                    <label >PAN Card *</label>
                                    {d?.POA?.panFileUrl &&
                                      (typeof d?.POA?.panFileUrl ===
                                        "string" ? (
                                        <div className={cssClasses.fileNameStyle} onClick={() => {
                                          handleOpenPreviewModal(
                                            d?.POA?.panFileUrl,
                                            "PAN Card"
                                          );
                                        }}>
                                          {
                                            typeof d?.POA?.panFileUrl ===
                                              "string"
                                              ? d?.POA?.panFileUrl
                                                ?.split("/")
                                                .pop()
                                              : d?.POA?.panFileUrl?.name
                                          }
                                        </div>

                                      ) : (
                                        <div className={cssClasses.fileNameStyle} onClick={() => {
                                          handleOpenPreviewModal(
                                            d?.POA?.panFileUrl?.url,
                                            "PAN Card"
                                          );
                                        }}>
                                          {
                                            typeof d?.POA?.panFileUrl?.url ===
                                              "string"
                                              ? d?.POA?.panFileUrl?.url
                                                .split("/")
                                                .pop()
                                              : d?.POA?.panFileUrl.name
                                          }
                                        </div>
                                      ))}                   </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </AccordionDetails>
                      </Accordion>

                    </div>
                  )}
                </>
              );
            })}
            <div className={cssClasses.formContainer} style={{ pageBreakBefore: isSelfFunded === "yes" ? "always" : "avoid" }}>
              <div style={{ display: "flex", gap: "0.8rem", width: "100%" }}>
                <div style={{ width: "50%" }}>
                  <FormControl
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "2rem",
                    }}
                  >
                    <FormLabel id="demo-controlled-radio-buttons-group" className={cssClasses.selfFundedText}>
                      Are you opting for loan?
                    </FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      name="controlled-radio-buttons-group"
                      value={isSelfFunded}
                    >
                      <FormControlLabel
                        className={cssClasses.selfFundedText}
                        value={"yes"}
                        control={<Radio color="default" disabled />}
                        label={<Typography className={cssClasses.selfFundedText}>Yes</Typography>}
                      />
                      <FormControlLabel
                        className={cssClasses.selfFundedText}
                        value={"no"}
                        control={<Radio color="default" disabled />}
                        label={<Typography className={cssClasses.selfFundedText}>No</Typography>}
                      />
                    </RadioGroup>
                  </FormControl>
                  {isSelfFunded === "yes" && <div className={cssClasses.middleDiv}>
                    <Stack direction="row" spacing={2}>
                      <FormControl>
                        <RadioGroup
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          key={bankType}
                          value={bankType}
                        >
                          {bankType === "nbfc" && <FormControlLabel
                            value="nbfc"
                            control={<Radio disabled />}
                            label={<Typography className={cssClasses.selfFundedText}>NBFC</Typography>}
                          />}
                          <FormControlLabel
                            value="bank"
                            control={<Radio disabled />}
                            label={<Typography className={cssClasses.selfFundedText}>Bank</Typography>}
                          />
                        </RadioGroup>
                      </FormControl>
                      <div>
                        <div className={cssClasses.formGroup}>
                          <input disabled value={radioName ? radioName : "Other"} required />
                        </div>
                        {radioName === "Other" && <div className={cssClasses.formGroup}>
                          <input disabled value={otherBank} required />
                        </div>}
                      </div>
                    </Stack>
                    <div className={cssClasses.formMainData} style={{ marginTop: "1.6rem" }}>
                      <div className={cssClasses.formGroup}>
                        <label htmlFor="loanSource">Loan Source</label>
                        <input disabled type="text" id="loanSource" name="loanSource" value={aggrementData?.data?.[0]?.loanDetails?.loanSource ? aggrementData?.data?.[0]?.loanDetails?.loanSource : "Other"} required />
                      </div>
                    </div>
                  </div>}
                </div>
                {isSelfFunded === "yes" &&
                  <div style={{ width: "50%", paddingTop: "1rem" }}>
                    <div className={cssClasses.formMainData}>
                      <div className={cssClasses.formGroup}>
                        <label htmlFor="addressLine3">Banker Name</label>
                        <input disabled type="text" id="addressLine3" name="addressLine3" value={aggrementData?.data?.[0]?.loanDetails?.name ? aggrementData?.data?.[0]?.loanDetails?.name : "-"} required />
                      </div>
                    </div>
                    <div className={cssClasses.formMainData}>
                      <div className={cssClasses.formGroup}>
                        <label htmlFor="addressLine3">Banker Contact Number</label>
                        <input disabled type="text" id="addressLine3" name="addressLine3" value={aggrementData?.data?.[0]?.loanDetails?.contactNumber ? aggrementData?.data?.[0]?.loanDetails?.contactNumber : "-"} required />
                      </div>
                    </div>
                  </div>}
              </div>
              {isSelfFunded === "yes" && modalData[0]?.applicant?.loanSanctionUrl?.url && <div className={cssClasses.middleDiv} style={{ flexDirection: "column" }}>
                <Typography sx={{ ...labelStyle }}>
                  Loan Sanction Letter <span style={{ color: "red" }}>*</span>{" "}
                </Typography>
                <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
                  <Button
                    style={{
                      color: "#000000",
                      backgroundColor: "#fff",
                      fontSize: "1.4rem",
                      lineHeight: "2rem",
                      fontFamily: "Inter-Medium !important",
                      width: "80%",
                    }}
                    btnTextStyle={{
                      textOverflow: "ellipsis",
                      width: "100%",
                      overflow: "Hidden",
                      whiteSpace: "nowrap",
                    }}
                    btnName={
                      typeof modalData[0]?.applicant?.loanSanctionUrl?.url ===
                        "string"
                        ? modalData[0]?.applicant?.loanSanctionUrl?.url
                          .split("/")
                          .pop()
                        : modalData[0]?.applicant?.loanSanctionUrl?.url?.name
                    }
                    clicked={() => {
                      handleOpenPreviewModal(
                        modalData[0]?.applicant?.loanSanctionUrl?.url,
                        "Loan Sanction"
                      );
                    }}
                  />
                </div>
              </div>}
            </div>
          </div>
          <div className={cssClasses.footer}>
            <Button
              style={{
                color: isCreateDraft ? "#000" : "#fff",
                backgroundColor: isCreateDraft ? "#FFF" : "#006AFF",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Inter-Medium !important",
                width: "20%",
              }}
              btnName={"Close"}
              clicked={() => {
                handleClose();
              }}
            />
            {isCreateDraft && (
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: "#006AFF",
                  fontSize: "1.4rem",
                  lineHeight: "2rem",
                  fontFamily: "Inter-Medium !important",
                  width: "20%",
                }}
                btnName={"Submit"}
                clicked={() => {
                  handleCreateDraft(true);
                }}
              />
            )}
          </div>
        </Box>
      </Modal>
      {showPreviewModal && (
        <PreviewAggrementImageModal
          open={showPreviewModal}
          handleClose={() => {
            setShowPreviewModal(false);
          }}
          value={selectedFile}
          title={name}
        />
      )}
    </>
  );
}

export default PreviewAggrementConfirmationModal;
